import { takeLatest, Effect } from 'redux-saga/effects';
import { types as imageTypes, actions as imageActions } from 'ducks/supplierProductEnquiry/attachments/images';
import { connectSagaToApi } from './../../utils';
import * as api from 'api/supplierProductEnquiry/attachments/images';

export default function* rootCustomerSaga(): IterableIterator<Effect> {
  yield takeLatest(imageTypes.fetch, connectSagaToApi(imageActions, 'fetch', api.fetch));
}
